import { useState, useEffect ,useCallback , useRef} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";
import QRCode from 'qrcode.react';

import Multiselect from 'multiselect-react-dropdown';
import "react-data-table-component-extensions/dist/index.css";
import * as React from 'react';
import $ from 'jquery';
import TableToExcel from '@linways/table-to-excel';
import DataTable from 'react-data-table-component'; 
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as leadActions from "../../actions/leadActions";
import * as reportActions from "../../actions/reportActions";
import Loader from "../../components/Loader";
import LoanVersioning from './LoanVersioning';
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import AccessDenied from '../common/AccessDenied';
import * as beatPlanActions from "../../actions/beatPlanActions";
import * as masterAction from "../../actions/masterAction";
import PreEmiPopUp from './PreEmiPopUp';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const PreEmiCalling = (props) => {
    const theme = useTheme();
    const { id } = useParams();
    const { urlAgreementNo } = useParams();
    const { urlIdentifier } = useParams();    
    const { brief } = useParams();
     const location = useLocation();
    const { actions, usersData } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    
    const navigate = useNavigate();
 
    const [permissions, setPermissions] = useState([]);
    const [userRoleType, setUserRoleType] = useState('');
    const [loggeInUserID, setLoggeInUserID] = useState('');

    const [allTags, setAllTags] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [businessDoneLoans, setBusinessDoneLoans] = useState([]);
    const [loanDetailsEMIS, setLoanDetailsEMIS] = useState([]);
    const [backOfficeUsersArr, setBackOfficeUsersArr] = useState([]);
    const [allUsersArr, setAllUsersArr] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const [sendCrifOpenModal, setSendCrifOpenModal] = React.useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sendCrifFormData, setSendCrifFormData] = useState({ email_address: '' });
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);

    const [beatPlanLocation, setBeatPlanLocation] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);
    const [selectedVisitType, setSelectedVisitType] = useState([]);
    const [loanID, setLoanID] = useState('');
    const [loanDetailStatus, setLoanDetailStatus] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [versioningLoans, setVersioningLoans] = useState([]);
	const [businessDoneLoan, setBusinessDoneLoan] = useState([]);
    const [reportName, setReportName] = useState('');
    const [cronRunDateArr, setCronRunDateArr] = useState([]);
    const [cronRunTabsReloadStatus, setCronRunTabsReloadStatus] = useState(true);
    const [activeLoanTab, setActiveLoanTab] = useState(0);
    const [auditAllLoansButtonStatus, setAuditAllLoansButtonStatus] = useState(false);

    const [keyword, setKeyword] = useState('');
    const [isENACHRegistrationChecked, setIsENACHRegistrationChecked] = useState(false);
    const [selectedTag, setSelectedTag] = useState('');
    
    const [totalOutstandingAmt, setTotalOutstandingAmt] = useState(0);
    const[intentUrlRazorpay, setIntentUrlRazorpay] = useState('');
    const [allMasterProfiles, setAllMasterProfiles] = useState([]);
 
    const [formValues, setFormValues] = useState({
        amount: '',
        amountRazorpay:''
    });

    const [qrCodeAmount, setQrCodeAmount] = useState(0);
    const [qrCodeAmountRazorpay, setQrCodeAmountRazorpay] = useState(0);

    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [compressedFile, setCompressedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isMobile , setIsMobile] = useState(null);

    const childRef = useRef();
    const fileInputRef = useRef();
    const cameraInputRef = useRef();

    const [previews, setPreviews] = useState([]);
    const [compressedFiles, setCompressedFiles] = useState([]);
    const [imageDetails, setImageDetails] = useState([]); 
    const [preloaderSubmitStatus, setPreloaderSubmitStatus] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const RECORDS_PER_PAGE = 100;
    const [activeListIdentifier, setActiveListIdentifier] = useState('audit_records');
    const [openPreEmiCallingPopup, setOpenPreEmiCallingPopup] = useState(false); 
    const [showCreateCGCLeadStatus, setShowCreateCGCLeadStatus] = useState(false); 
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [showCreateCGCLeadFieldsStatus, setShowCreateCGCLeadFieldsStatus] = useState(false); 
    const [selectedItem, setSelectedItem] = useState([]);     
    const [selectedFormItem, setSelectedFormItem] = useState({
        totalAmt: '',
        callDate: '',
        callFeedback:'',
        finalDisposition:'',
        remarks:'',
        referenceAvailable:'no',
        createCGCLead:'',
        assignedTeleCallerUserId:'',
        name:'',
        mobile:'',
        address:'',
        city:'',
        district:'',
        state:'',
        pincode:'',
        assigned_to:'',
        oem_usage:'',
        lead_profile:'',
        oem:'',
        model_name:'',
        cgc_referrer_amount:'',
        
      });
    const [popupModalTitle, setPopupModalTitle] = useState('Lead Call Details');
     const [isCreateCGCLeadChecked, setIsCreateCGCLeadChecked] = useState(false);
     const [assignedTeleCallerId, setAssignedTeleCallerId] = useState('');
     const [isSubmitDetailEnabled, setIsSubmitDetailEnabled] = useState(true);
     const [fileID, setFileID] = useState('');
     const [allStates, setAllStates] = useState([]);
     const [allOemUsage, setAllOemUsage] = useState([]);
     const [allOem, setAllOem] = useState([]);
     const [duplicateLeadData, setDuplicateLeadData] = useState(null);
     const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
     const mobileApiHitRef = useRef('');
 
    useEffect(() => {

        if (brief !== undefined ) {
            setReportName(brief); 
        }
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        const roleName = localStorage.getItem('authUserRoleName'); 
        if (authToken === null) {
            navigate('/login');
        }

        if (id !== undefined ) {
            const idVal = atob(id);            
            setLoanID(idVal); 
             setLoanDetailStatus(true);
        } 

        if (urlIdentifier !== undefined ) {
         setActiveListIdentifier(urlIdentifier);
        }

        if (roleName !== undefined ) {
           setUserRoleType(roleName);
        } 

         const  objl = { start: "0", length: config.MAX_RECORDS };
        const requestDatal = encryptData(objl);
        const responsel = actions.masterProfileData(requestDatal, false);
        responsel
            .then((result) => {
            // console.log("Promise resolved -  master profile data:", result);
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter(
                (item) => item.status === "1"
                );
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.lead_profile_name.localeCompare(b.lead_profile_name)
                );
                setAllMasterProfiles(sortedResultArr);
            }
            })
            .catch((error) => {
            //  console.error("Promise rejected -  source data :", error);
            });

         setAllStates([]);
        // setAllAddressTypes([]);
        const objStates = { start: "0", length: config.MAX_RECORDS };
        const requestDataStates = encryptData(objStates);
        const responseStates = actions.masterStatesData(requestDataStates, false);
        responseStates
            .then((result) => {
            // console.log("Promise resolved -  master profile data:", result);
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                setAllStates(resultArr);
            }
            })
            .catch((error) => {
            //  console.error("Promise rejected -  source data :", error);
            });

             const obj = { start: "0", length: config.MAX_RECORDS };
                const requestData = encryptData(obj);
                const response = actions.getOemUsage(requestData, false);
                response
                  .then((result) => {
                    //   console.log("Promise resolved -  campaignData:", result);
                    if (result.data.success === 1) {
                      const results = result.data.data.data;
                      const resultArr = Object.keys(results).map((key) => results[key]);
                      const filteredResultArr = resultArr.filter(
                        (item) => item.status === "1"
                      );
                      const sortedResultArr = filteredResultArr.sort((a, b) =>
                        a.oem_usage_name.localeCompare(b.oem_usage_name)
                      );
                      setAllOemUsage(sortedResultArr);
                    }
                  })
                  .catch((error) => {
                    //  console.error("Promise rejected -  campaignData :", error);
                  });

    }, [setLoanID,id,setReportName,setActiveListIdentifier,urlIdentifier,setUserRoleType,setFileID,setAllStates,setAllOemUsage,setAllMasterProfiles]);

     useEffect(() => {
        const obj = { start: "0", length: config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getOem(requestData, false);
        response
          .then((result) => {
            //   console.log("Promise resolved -  campaignData:", result);
            if (result.data.success === 1) {
              const results = result.data.data.data;
              const resultArr = Object.keys(results).map((key) => results[key]);
              const filteredResultArr = resultArr.filter(
                (item) => item.status === "1"
              );
              const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.oem_name.localeCompare(b.oem_name)
              );
              setAllOem(sortedResultArr);
            }
          })
          .catch((error) => {
            //  console.error("Promise rejected -  campaignData :", error);
          });
      }, [setAllOem]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {

                if (Object.prototype.hasOwnProperty.call(result?.data, 'user_info') ) {
                 //   setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);
                }

                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Audit Report')?.view_permission;
                setPermissions(permissionsData);
                setViewModulePermissionStatus(hasViewPermissions);
                setUserHasPermission(hasViewPermissions);

                
            }
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });
    }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID]);
 
    const handleKeywordChange = (event) => {
        setKeyword(event.target.value); 
    };
    const handleENACHRegistrationChange = (event) => {
         setIsENACHRegistrationChecked(event.target.checked);
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        setPreloaderStatus(true);

        const today = new Date();
        const todayFormatted = formatDate(today);

        setStartDate(todayFormatted);
        setEndDate(todayFormatted);

        setValue("start_date", todayFormatted);
        setValue("end_date", todayFormatted);

        // console.log("111111 - id = ",id);

        if (id !== undefined ) {
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setVersioningLoans([]);
            const idVal = atob(id); 
            const agreementNo = atob(urlAgreementNo);  
            
            let reportName = '';
            if (brief !== undefined ) {
                reportName = brief; 
            }
            // alert(reportName);
            // alert(idVal);      
            setLoanID(idVal); 
             setLoanDetailStatus(true);
             setAuditAllLoansButtonStatus(true);
 
              setLoading(true);

            
             if (userRoleType === '') return;
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setBusinessDoneLoan([]);


            const offset = (page - 1) * RECORDS_PER_PAGE;
             const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted ,'loan_id' : idVal ,'reportName' : reportName, 'keyword' : keyword ,'activeListIdentifier' : activeListIdentifier , "userRoleType" :userRoleType,"fileID":fileID };
                const requestData = encryptData(params);
                setBackOfficeUsersArr([]); setAllUsersArr([]);
                const response = actions.getPreEmiCAllingData(requestData, false);
                response.then((result) => {
                    setLoading(false);
                    setPreloaderStatus(false);
                    // console.log("Promise resolved -  getPreEmiCAllingData:", result);
                    setTotalRows(result.data?.total || 5000);
                    if (result.data.success === 1) {
                        setPreloaderStatus(false);
                        const results = result.data.data.all_records;
                        const resultArr = Object.keys(results).map((key) => results[key]);
                        setVersioningLoans(resultArr);
                        setBusinessDoneLoans(resultArr);    
                        console.log("resultArr = ",resultArr);
                        setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []); 
                        const defaultTabIndex = (resultArr.length >0) ? (resultArr.length - 1) : 0;
                        setActiveTab(defaultTabIndex);
                         setAllUsersArr(result.data?.allUsers ?? []);     
                        
                            
                    }  

                }).catch((error) => {
                    setPreloaderStatus(false);
                    console.error("Promise rejected -  getPreEmiCAllingData:", error);
                });
        }else{ 
            if (userRoleType === '') return;
            setPreloaderStatus(false);
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setBusinessDoneLoan([]);


            setLoading(true);
            const offset = (page - 1) * RECORDS_PER_PAGE;
            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted, 'keyword' : keyword , "page" : page ,"limit": RECORDS_PER_PAGE,
            "offset" : offset ,'activeListIdentifier' : activeListIdentifier, "userRoleType" :userRoleType ,"fileID":fileID};
            const requestData = encryptData(params);
            setBackOfficeUsersArr([]);  setAllUsersArr([]);
            const response = actions.getPreEmiCAllingData(requestData, false);
            response.then((result) => {
                setLoading(false);
                // console.log("Promise resolved -  getPreEmiCAllingData:", result);
                setTotalRows(result.data?.total || 0);
                if (result.data.success === 1) {
                    setPreloaderStatus(false);
                    const results = result.data.data.all_records;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    console.log("resultArr 3 = ",resultArr);
                    setBusinessDoneLoans(resultArr);
                    setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setAllUsersArr(result.data?.allUsers ?? []);
                }  
            }).catch((error) => {
                setPreloaderStatus(false);
                console.error("Promise rejected -  getPreEmiCAllingData:", error);
            });
        }

        
    }, [setBusinessDoneLoans,setLoanID,setLoanDetailsEMIS,setLoanDetailStatus,id, setBusinessDoneLoan,setVersioningLoans, setCronRunDateArr, setTotalOutstandingAmt, totalOutstandingAmt,page ,setBackOfficeUsersArr, setAllUsersArr]);
 
    const onSubmit = (data) => {

        if (userRoleType === '') return; 
        setBusinessDoneLoans([]);
        
        setPreloaderStatus(true);
        setLoading(true);
        const offset = (page - 1) * RECORDS_PER_PAGE;
 
        const params = {
            'keyword' : keyword,
            'start': '0',
            'length': config.MAX_RECORDS,"brief" :'intray_outtray_report', "page" : page ,"limit": RECORDS_PER_PAGE,
            "offset" : offset,
            'activeListIdentifier' : activeListIdentifier , "userRoleType" :userRoleType,"fileID":fileID
        };

        const requestData = encryptData(params);
       setBackOfficeUsersArr([]);  setAllUsersArr([]);
        const response = actions.getPreEmiCAllingData(requestData, false);
        response.then((result) => {
            setLoading(false);
            setPreloaderStatus(false);
            // console.log("Promise resolved -  lead list:", result);
            setTotalRows(result.data?.total || 0);
            
            if (result.data.success === 1) {
                
               
                const results = result.data.data.all_records;
                const resultArr = Object.keys(results).map((key) => results[key]);

                setBusinessDoneLoans(resultArr);
                setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []);
                setAllUsersArr(result.data?.allUsers ?? []);
                console.log("resultArr 2 = ",resultArr);

            }  
        }).catch((error) => {
            setPreloaderStatus(false);
            console.error("Promise rejected -  lead list:", error);
        });
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setPage(newPage);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
        setPage(1);
    };

    const filteredItems = businessDoneLoans.filter(item => {
        const AgreementNo = item.AgreementNo?.toLowerCase() || '';
        const CustomerName = item.CustomerName?.toLowerCase() || '';
        return (
            AgreementNo.includes(searchQuery.toLowerCase()) ||
            CustomerName.includes(searchQuery.toLowerCase())            
        );
    });

    const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
    const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
    const paginatedItems = filteredItems.slice();
    const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);
     
    const exportLoansReport = async () => {
        const table = document.getElementById('exportLoansReportExcelFile');
        
        // Debugging log: Check if table is correctly selected
        console.log('Table:', table);
        
        const headersRow = table.querySelector('thead tr');
        const headers = Array.from(headersRow.querySelectorAll('th'));
        const actionColumnIndex = headers.findIndex(th => th.innerText.trim() === 'Action');
        
        // Debugging logs: Check headersRow and actionColumnIndex
        console.log('Headers Row:', headersRow);
        console.log('Action Column Index:', actionColumnIndex);
        
        if (actionColumnIndex !== -1) {
            // Debugging log: Check the header element to remove
            console.log('Header to Remove:', headers[actionColumnIndex]);
            
            headersRow.removeChild(headers[actionColumnIndex]);
        } else {
            console.log('Action column not found.');
        }
    
        TableToExcel.convert(table, {
            name: 'IntrayOutTray.xlsx',
            sheet: {
                name: 'Audit-Report',
            },
        });
    
        // Re-append the action column header if it was removed
        if (actionColumnIndex !== -1) {
            headersRow.appendChild(headers[actionColumnIndex]);
        }
    };
 
    useEffect(() => {
        if (cronRunDateArr.length > 0) {
            setActiveLoanTab(cronRunDateArr.length - 1);
        }
    }, [cronRunDateArr, setActiveLoanTab]);

    const goBackBtn = (event) => {
        setLoanDetailStatus(false);
        setAuditAllLoansButtonStatus(false);
        const url = `/dashboard/allcloud-loans-report`;
       // window.open(url, '_self');
        navigate(url);
      };

    const handleUAssignedTeleCallerChange = (e) => {  
            setAssignedTeleCallerId(e.target.value);
    }
    const selectRefSL = useRef(null);  

    const handleUserChange = (e,leadId) => {  
            if (leadId !== "") {
                  const obj = {
                    start: "0",
                    length: config.MAX_RECORDS,
                    backOfficeUser: e.target.value,
                    lead_id: leadId,
                    "userRoleType" : userRoleType
                  };
                  const requestData = encryptData(obj);            
                  const response = actions.assignLeadToBackOfficeUser(requestData);
                  response
                    .then((result) => {                          
                       if (result.data.success === 1) {
                            toast.success(result.data.data.message, {
                              position: "top-right",
                            });
                            onSubmit();// reload list
                      }
                    })
                    .catch((error) => {
                     toast.error(error, {
                                 position: "top-right",
                               });
                    });
                }  
    }
  
   
      const moneyFormatIndia = (number) => {
        if (number !== undefined && number !== null && !Number.isNaN(Number(number))) {
            number = parseFloat(number).toFixed(2);  // Ensure two decimal places
    
            const [integerPart, decimalPart] = number.split('.');
    
            const lastThreeDigits = integerPart.slice(-3);
            const otherDigits = integerPart.slice(0, -3);
    
            let formattedIntegerPart;
            if (otherDigits !== '') {
                formattedIntegerPart = `${otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${lastThreeDigits}`;
            } else {
                formattedIntegerPart = lastThreeDigits;
            }
    
            return `${formattedIntegerPart}.${decimalPart}`;
        }
    
        return '0.00';  // Default return value for invalid inputs
    };

    useEffect(() => {
        if (selectedFormItem) {
            Object.keys(selectedFormItem).forEach((key) => {
            setValue(key, selectedFormItem[key]);
            });
        }
        }, [selectedFormItem, setValue]);

     const btnOpenPreEmiCallingData = (item) => {    // buttonFun
        console.log("History Data", item.history_data);
        setOpenPreEmiCallingPopup(true);
        setShowCreateCGCLeadStatus(false);  
        setShowCreateCGCLeadFieldsStatus(false);
        setSelectedItem(item);
        setPopupModalTitle(`Edit Lead Call Details for ${item.Customer}`);
        setAssignedTeleCallerId('');
        setDuplicateLeadData(null);
        setShowDuplicateAlert(false);
        mobileApiHitRef.current = '';
        console.log("item Details 123", item);

       // Enable or disable submit detail button
            setIsSubmitDetailEnabled(item?.action !== 'created_cgc_lead');

            // Safely extract otherDetails only if it exists and has a callDate
            // const otherDetails =
            // item?.other_details && item?.other_details?.callDate
            //     ? item.other_details
            //     : {};

            // setShowCreateCGCLeadStatus(otherDetails?.referenceAvailable === 'yes');  
            // setShowCreateCGCLeadFieldsStatus(otherDetails?.createCGCLead === '1');
            // setIsCreateCGCLeadChecked(otherDetails?.createCGCLead === '1');
            // setAssignedTeleCallerId(otherDetails?.assignedTeleCallerUserId || '');
                setShowCreateCGCLeadStatus(false);
                setShowCreateCGCLeadFieldsStatus(false);
                setIsCreateCGCLeadChecked(false);
                setAssignedTeleCallerId('');
            // Populate form state
            // setSelectedFormItem({
            // preEmiCallingID: item?.id || '',
            // callDate: otherDetails?.callDate || '',
            // callFeedback: otherDetails?.callFeedback || '',
            // finalDisposition: otherDetails?.finalDisposition || '',
            // remarks: otherDetails?.remarks || '',
            // referenceAvailable: otherDetails?.referenceAvailable || 'no',
            // createCGCLead: otherDetails?.createCGCLead || '',
            // assignedTeleCallerUserId: otherDetails?.assignedTeleCallerUserId || '',
            // name: otherDetails?.name ||  '',
            // mobile: otherDetails?.mobile || '',
            // address: otherDetails?.address || '',
            // city: otherDetails?.city || '',
            // district: otherDetails?.district || '',
            // state: otherDetails?.state || '',
            // pincode: otherDetails?.pincode || '',
            // assigned_to: otherDetails?.assigned_to || '',
            // oem_usage: otherDetails?.oem_usage || '',
            // lead_profile: otherDetails?.lead_profile || '', 
            // oem: otherDetails?.oem || '',
            // model_name: otherDetails?.model_name || '',
            // cgc_referrer_amount: otherDetails?.cgc_referrer_amount || '',
            // });
            // setSelectedFormItem({
            //     preEmiCallingID: item?.id || '',
            //     callDate: otherDetails?.callDate || '',
            //     callFeedback: otherDetails?.callFeedback || '',
            //     finalDisposition: otherDetails?.finalDisposition || '',
            //     remarks: otherDetails?.remarks || '',
            //     referenceAvailable: otherDetails?.referenceAvailable || 'no',
            //     createCGCLead: otherDetails?.createCGCLead || '',
            //     assignedTeleCallerUserId: otherDetails?.assignedTeleCallerUserId || '',

            //     name: '',
            //     mobile: '',
            //     address: '',
            //     city: '',
            //     district: '',
            //     state: '',
            //     pincode: '',
            //     assigned_to: '',
            //     oem_usage: '',
            //     lead_profile: '',
            //     oem: '',
            //     model_name: '',
            //     cgc_referrer_amount: '',
            // }); 
            setSelectedFormItem({
                preEmiCallingID: item?.id || '',

                callDate: '',
                callFeedback: '',
                finalDisposition: '',
                remarks: '',
                referenceAvailable: 'no',
                createCGCLead: '',
                assignedTeleCallerUserId: '',

                name: '',
                mobile: '',
                address: '',
                city: '',
                district: '',
                state: '',
                pincode: '',
                assigned_to: '',
                oem_usage: '',
                lead_profile: '',
                oem: '',
                model_name: '',
                cgc_referrer_amount: '',
            });
            reset({
                callDate: '',
                callFeedback: '',
                finalDisposition: '',
                remarks: '',
                referenceAvailable: 'no',
                createCGCLead: '',
                assignedTeleCallerUserId: '',
                name: '',
                mobile: '',
                address: '',
                city: '',
                district: '',
                state: '',
                pincode: '',
                assigned_to: '',
                oem_usage: '',
                lead_profile: '',
                oem: '',
                model_name: '',
                cgc_referrer_amount: '',
            });
    };
    const handleClosePreEmiCalling = () => {     // Modal onclick closedFun
        setOpenPreEmiCallingPopup(false);
        setSelectedItem([]);
        setDuplicateLeadData(null);
        setShowDuplicateAlert(false);
        mobileApiHitRef.current = '';
        setPopupModalTitle('Lead Call Details');
        setSelectedFormItem({
                preEmiCallingID: '',
                callDate: '',
                callFeedback:'',
                finalDisposition:'',
                remarks:'',
                referenceAvailable:'no',
                createCGCLead:'',
                 assignedTeleCallerUserId:'' ,
                 name:'',
                mobile:'',
                address:'',
                city:'',
                district:'',
                state:'',
                pincode:'',
                assigned_to:'',
                oem_usage:'',
                lead_profile:'',
                oem:'',
                model_name:'',
                cgc_referrer_amount:'',
            });
    };

    const getMobileDetails = async () => {

    const mobile = selectedFormItem?.mobile;

    if (!mobile || mobile.length !== 10) {
        return;
    }

    try {

        const response = await agent.post(
            API.GET_PRE_EMI_MOBILE_DETAILS,
            { mobile }
        );

        console.log("Duplicate Response", response);

        if (
            response?.data?.success === 1 &&
            response?.data?.data
        ) {
            setDuplicateLeadData(response.data.data);
            setShowDuplicateAlert(true);
        }

    } catch (error) {
        console.log(error);
    }
};

const useDuplicateLeadData = () => {

    if (!duplicateLeadData) return;

    setSelectedFormItem(prev => ({
        ...prev,

        name: duplicateLeadData.name || '',
        mobile: duplicateLeadData.mobile || '',
        address: duplicateLeadData.address || '',
        city: duplicateLeadData.city || '',
        district: duplicateLeadData.district || '',
        state: duplicateLeadData.state || '',
        pincode: duplicateLeadData.pincode || '',
        assigned_to: duplicateLeadData.assigned_to || '',
        oem_usage: duplicateLeadData.oem_usage || '',
        lead_profile: duplicateLeadData.lead_profile || '',
        oem: duplicateLeadData.oem || '',
        model_name: duplicateLeadData.model_name || '',
        cgc_referrer_amount: duplicateLeadData.cgc_referrer_amount || '',
    }));

    setShowDuplicateAlert(false);

    toast.success("Data prefilled successfully");
};
 
     const handlePreEmiCallingChange = (e) => {
        console.log("TEST");
        const { name, value } = e.target;

        if (name === 'referenceAvailable' ) { 
            if(value === 'yes'){
                setShowCreateCGCLeadStatus(true);
                
            }else{
                setShowCreateCGCLeadStatus(false);
                setShowCreateCGCLeadFieldsStatus(false);
            }
                 
        }
        

        if (name === 'createCGCLead' ) { 
             setIsCreateCGCLeadChecked(e.target.checked);
             if(e.target.checked){
                setShowCreateCGCLeadFieldsStatus(true);
                
            }else{
                setShowCreateCGCLeadFieldsStatus(false);
            }
        } 

        // setSelectedFormItem({
        // ...formValues,
        // [name]: value,
        // });
        setSelectedFormItem(prev => ({
            ...prev,
            [name]: value,
        }));
    };
    

    const handlePreEMICallingFormSubmit = (data) => { 
       
         if (data.callDate === '') {
          toast.error("Call Date is required.", {
            position: "top-right",
          });
         } else if (data.callFeedback === '') {
          toast.error("Call Feedback is required.", {
            position: "top-right",
          }); 
         } else if (data.finalDisposition === '') {
          toast.error("Final Disposition is required.", {
            position: "top-right",
          }); 
         } else if (data.remarks === '') {
          toast.error("Remarks is required.", {
            position: "top-right",
          });          
        } else {
 
           const params = { 
                preEmiCallingID: selectedItem?.id || '', 
                callDate: data.callDate,
                callFeedback: data.callFeedback,
                remarks: data.remarks,
                finalDisposition: data.finalDisposition,
                referenceAvailable: data.referenceAvailable, 
                createCGCLead: isCreateCGCLeadChecked, 
                assignedTeleCallerUserId: assignedTeleCallerId,
                mobile: data.mobile,
                name:data.name,
                address:data.address,
                city:data.city,
                district:data.district,
                state:data.state,
                pincode:data.pincode,
                assigned_to:data.assigned_to,
                oem_usage:data.oem_usage,
                lead_profile:data.lead_profile,
                oem:data.oem,
                model_name:data.model_name,
                cgc_referrer_amount:data.cgc_referrer_amount,    
            }; 
            console.log('testing', params.lead_profile);
            console.log("Updated params: ", params);
            const requestData = encryptData(params);
            const response = actions.savePreEmiCallingActionDetails(requestData);
            response
                  .then((result) => {
                    // console.log("Promise resolved - add/edit lead form:", result);
                    if (result.data.success === 1) {
                      toast.success(result.data.message, {
                        position: "top-right",
                      });
                      
                      handleClosePreEmiCalling();
                      onSubmit();// reload list
                    } else {
                      toast.error(result.data.message, {
                        position: "top-right",
                      });
                    }
                  })
                  .catch((error) => {
                    // console.error("Promise rejected - add/edit lead form:", error);
                    toast.error(error, {
                      position: "top-right",
                    });
                  });
        }
      }

       const onSavePreEmiCallingAction = (item) => { 
        
       

          //  console.log("Updated item: ", item);
           // setPreloaderStatus(true); 
                
          /*  // alert(item.emi_amount);
            const params = { 'lead_id': item.id, 'selectedFormItem': selectedFormItem }; 
            const requestData = encryptData(params);
            const response = actions.sendEnachUPIRegistrationDetails(requestData);
            response.then((result) => {
                    
                if (result.data.success === 1) { 
                    console.log("response = ", result.data.data); 
                    setPreloaderStatus(false);
                            toast.success(result.data.message, {
                                position: "top-right",
                            });
                        const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType,
                            "is_cam_leads": isCamChecked };
                        const requestData = encryptData(obj);
                        const response = actions.leadsData(requestData);
                        response.then((result) => {
                            console.log("Promise resolved -  lead list:", result);
                            if (result.data.success === 1) {
                            setShowLeadDetails(true);
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);
                            setAllLeads(resultArr);
                            }
                        }).catch((error) => {
                            console.error("Promise rejected -  lead list:", error);
                        });   
                    
                } else {
                    setPreloaderStatus(false);
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
        
                setOpenAmt(false); 
                setProposedAmt('');
                setProposedDebitDate('');
                setEnachItem([]); 
                setEnachType('');
            }).catch((error) => {
                setPreloaderStatus(false);
                toast.error(error, {
                    position: "top-right",
                });
            }); */
       };
    
    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };

    let columns = [];
    if(activeListIdentifier === 'audit_records'){
           columns = [   
            {
                name: 'Uploaded By',
                selector: row => row.createdByName,
                sortable: true,
            },     
            {
                name: 'Date',
                selector: row => row.created_on,
                sortable: true,
            }, 
            {
                name: 'File',
                selector: (row) => row.file,
                sortable: true,
                cell: (row) => (
                    row.file ? (
                    <a
                        href={row.file_url}              // file URL or path
                        download                     // makes it downloadable
                        target="_blank"              // open in new tab if needed
                        rel="noopener noreferrer"    // security best practice
                        style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                        }}
                    >
                        {row.file}
                    </a>
                    ) : (
                    <span style={{ color: 'gray' }}>No file</span>
                    )
                ),
                },
           {
            name: 'Total Records',
            selector: row => row.totalRecords,
            sortable: true,
            cell: row => (
                <>
                <span
                    role="button"
                    tabIndex={0}
                    onClick={() => listDisplayHandler('file_records', row)}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && listDisplayHandler('file_records', row)}
                    style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                    {row.totalRecords}
                    </span>
                 
                </>
            )
            }
        ];

    }else{

          columns = [
        
            {
                name: 'Loan Date',
                selector: row => row.loan_date_formatted,
                sortable: true,
            },
            {
                name: 'AgreementNo',
                selector: row => row.AgreementNo,
                sortable: true,
            },
            {
            name: 'Lead Details',
            selector: row => row.mobile,
            sortable: false,
            cell: row => (
                <div>
                Mobile : <a
                    href={`/dashboard/edit-lead/${btoa(row.id)}`}
                    style={{ textDecoration: 'none', color: 'blue' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {row.mobile}
                </a>
                <div style={{ fontSize: '12px', color: '#555' }}>
                    Customer Name: {row.Customer}
                </div>
                </div>
            ),
            },
            
        
        {
            name: 'User',
            selector: row => (
                <>
                <div>{row.User}</div>
                {backOfficeUsersArr?.length > 0 && userRoleType !== 'User' && (
                    <div className="d-none" style={{ fontSize: '12px', color: '#666' }}>
                    <select
                        id={`back_office_user_id_${row.id}`}
                        name="back_office_user_id"
                        className="form-select"
                        value={row.backOfficeUser || ""}
                        onChange={(event) => handleUserChange(event, row.id)}
                        ref={selectRefSL}
                    >
                        <option value="">Assign to User</option>
                        {backOfficeUsersArr.map((option) => (
                        <option key={option.user_id} value={option.user_id}>
                            {option.name}
                        </option>
                        ))}
                    </select>
                    </div>
                )}
                </>
            ),
            sortable: true,
            },
        
            {
            name: 'Action',
            sortable: true,
            cell: (row) => (
                <>
                {/* Show text if action is 'created_cgc_lead' */}
                {row.action === 'created_cgc_lead' && (
                    <>&nbsp;</>
                )}

                {/* Always show the button */}
                <button
                    style={{ margin: '0.2rem 0rem' }}
                    type="button"
                    className="badge btn text-white float-right"
                    onClick={(e) => {
                    e.preventDefault();
                    btnOpenPreEmiCallingData(row);
                    }}
                >
                    <i className="bi bi-pen" style={{ color: 'black' }} />
                </button>
                    {row.history_data?.length > 0 && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-info ms-1"
                            onClick={() => {
                                setSelectedItem(row);
                                setOpenHistoryModal(true);
                            }}
                            title="View History"
                        >
                            <i className="bi bi-eye-fill" />
                        </button>
                    )}
                </>
            ),
            }
            
            
        ];
    }

    // Conditional row styles to change text color
        const conditionalRowStyles = [
            {
            when: row => row.AgreementNo === 'Success',   
            style: {
                color: 'green',
            },
            },
            {
            when: row => row.AgreementNo === 'Aborted',  
            style: {
                color: 'red',
            },
            },
            {
            when: row => row.AgreementNo === 'Failed',  
            style: {
                color: 'red',
            },
            },
        ];

    

    function isMobileDevice() {
     return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

     const handleImageChange = async (event) => {
    setPreloaderStatus(true);
    const file = event.target.files[0];
    if (!file) return;

    const options = {
        maxSizeMB: 1,
        useWebWorker: true,
        maxWidthOrHeight: undefined,
    };

    try {
        const compressedFile = await imageCompression(file, options);

        const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
        });

        const imageData = {
        name: file.name,
        originalSize: (file.size / 1024).toFixed(2),
        compressedSize: (compressedFile.size / 1024).toFixed(2),
        previewUrl: URL.createObjectURL(compressedFile),
        base64: base64Data,
        };

        setPreviews([imageData.previewUrl]);
        setCompressedFiles([compressedFile]);
        setSelectedDocumentFiles([{ file: imageData.base64, name: imageData.name }]);
        setImageDetails([imageData]);
        setPreloaderStatus(false);
    } catch (error) {
        console.error("Image processing failed:", error);
        setPreloaderStatus(false);
    }
    };
    
        const handleDelete = (index) => {
            // Revoke preview URL
            setImageDetails(prevDetails => {
                const target = prevDetails[index];
                if (target?.previewUrl) {
                URL.revokeObjectURL(target.previewUrl);
                }
    
                const newDetails = prevDetails.filter((_, idx) => idx !== index);
    
                // Sync other states based on new imageDetails
                setPreviews(newDetails.map(img => img.previewUrl));
                setCompressedFiles(prev => prev.filter((_, idx) => idx !== index));
                setSelectedDocumentFiles(newDetails.map(img => ({
                file: img.base64,
                name: img.name
                })));
    
                return newDetails;
            });
            };
    
    const handleDocumentFileChange = (e) => {
    const file = e.target.files[0]; // Only take the first file
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
        const base64Data = event.target.result;
        const fileName = file.name;
        setSelectedDocumentFiles([{ file: base64Data, name: fileName }]);
    };
    reader.readAsDataURL(file);
};

    const [openPaymentModal, setOpenPaymentModal] = React.useState(false);
    const btnOpenPaymentModal = () => setOpenPaymentModal(true);
    const handlePaymentModalClose = () => {
        setOpenPaymentModal(false);
        setSelectedDocumentFiles([]);  
    };

    const handleCallChild = () => {
       const tab = document.getElementById('pills-payment_documents-tab');
       if (tab) {
         tab.click();
        } 
    };
 
    const handlePaymentFormSubmit = (data) => {
        
        if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {
            const params = {"upload_file": selectedDocumentFiles , "AgreementNo" : businessDoneLoan.AgreementNo};
             setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadLoanPaymentData(requestData, navigate);

            response.then((result) => {
                 if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpenPaymentModal(false);
                    setSelectedDocumentFiles([]);
                    setImageDetails([]);
                    handleCallChild();  
                   
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const [open, setOpen] = React.useState(false);
    const btnOpenUploadMissingData = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSelectedItrFiles([]); // Reset selected ITR files
    };
    const [selectedItrFiles, setSelectedItrFiles] = useState([]);

    const handleItrFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedItrFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    

    const handleFormSubmit = (data) => {

        if (!selectedItrFiles || selectedItrFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {

            const params = {"upload_file": selectedItrFiles };

            // setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadMissingData(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - uploadLeads form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpen(false);
                    setSelectedItrFiles([]);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    }; 
    
    const { importName } = useParams();
    const [pageHeading , setPageHeading]  = useState('');
    const [iframeSrc , setIframeSrc]  = useState('');
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
	    const loggeIdUserId = localStorage.getItem('loggeIdUserId');
        let logUserId = loggeIdUserId;
        if(loggeIdUserId !== undefined && loggeIdUserId !=='' && loggeInUserID !== undefined && loggeInUserID !==''){
            logUserId = loggeInUserID;
         }
         
        const authToken = localStorage.getItem('authToken');
        let appUrl = config.APP_URL;
        appUrl = appUrl.replace('/public/', '/'); 
            setPageHeading('Loans Tagging');
            setIframeSrc(`${appUrl}excel_report/excel_import_pre_emi_calling.php?referrer=${btoa('lms_page')}&authToken=${authToken}&loggeIdUserId=${logUserId}`);        
        setIframeLoaded(true);
    }, [importName, setIframeLoaded]);

    const handleIframeLoad = () => {
        setIframeLoaded(true);
    }; 
     
    const [showHideTagStatus, setShowHideTagStatus] = useState(true);
    const handleToggle = () =>{
         setShowHideTagStatus(prevState => !prevState);  
    }
 
 
    if (!userHasPermission) {
        // Redirect or render an access denied message
      //  return <AccessDenied />;
    }


    useEffect(() => {
            if (urlIdentifier !== null) {
                console.log('ready to update list');
                onSubmit();
            }
    }, [activeListIdentifier,userRoleType,urlIdentifier,fileID]);

    const listDisplayHandler = (listIdentifier,item='') => {
        setActiveListIdentifier(listIdentifier);
        setFileID(item?.id || '');
        setKeyword('');
    } 
 
    return (
        <>  
            <Helmet>
                <title>CGC Calling</title>
            </Helmet>
            <Container>                
                <div id='main-wrap'  className={loanDetailStatus ? "mb-3 mmt-7 filter-" : "mb-3 mmt-7 filter-"}>

                     <div>                  
                    {(showHideTagStatus) && (<div className='table-wrap'>
                        {!iframeLoaded && <div><div className='p-spinner'><div className="spinner">&nbsp;</div></div></div>}
                        <iframe
                            title="Report"
                            width="100%"
                            height="130"
                            src={iframeSrc}
                            frameBorder="0"
                            allowFullScreen
                            onLoad={handleIframeLoad}
                            style={{ display: iframeLoaded ? 'block' : 'none' }}
                        />
                    </div>
                    )
                    }
                </div> 
                 <div className='row mx-0'>&nbsp;</div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row mx-0'>

                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>Keyword</span>
                                        <input type='text' name='keyword' id='keyword' className='form-control'{...register('keyword')} placeholder="Enter your value here..." onChange={handleKeywordChange}/>
                                    </label>
                                </div>
                            </div>
 

                            <div className='col'>
                                <div className='form-group mb-2'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button className='btn btn-primary'>Search</button>

                                     { fileID !=='' && (  
                                        <> 
                                        &nbsp;
                                         <button className={ activeListIdentifier === 'intray' ? "btn btn-success text-white" : "btn btn-success text-white"} onClick={() => listDisplayHandler('audit_records','')}>Back to Audit Trails</button>  
                                        </>  
                                        )}
                                </div>

                               
                            </div>
  
                        </div>
                    </form>
                </div> 

                <div id="main-wrap">
                    <div className="row justify-content-between mt-4">
                        <div className="col-md-7">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                              CGC Calling
                            </Typography> 
                        </div>
                        <div className='col-md-5 text-end ps-lg-5'>                            
                        {(!loanDetailStatus) && (
                            <>
                            <div className="form-group d-flex justify-content-end align-items-center">
                                <label htmlFor="search" className='w-100 d-none'>
                                    {/* Search : */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        id="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </label>
                                <button className="btn btn-info text-white ms-3 d-none" onClick={() => exportLoansReport()}>
                                    Export
                                </button>                                
                            </div>
                            <div className="float-left mb-2"><b>Total Records : {totalRows}</b></div>
                            </>
                        )}                      
                        </div>
                    </div>

                    
                     

                        <DataTable
                            // title="My DataTable with Expandable Rows"
                            columns={columns}
                            data={businessDoneLoans}
                            progressPending={loading}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={RECORDS_PER_PAGE}
                            onChangePage={handlePageChange}
                            conditionalRowStyles={conditionalRowStyles}
                            // pagination
                        />
                </div>
                {preloaderStatus && <Loader />}
            </Container>
            

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Upload Additional Data</h4>
                        <Button onClick={handleClose} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='file'
                                                    id='itr_file'
                                                    name='itr_file'
                                                    className='form-control'
                                                    {...register('itr_file')}
                                                    onChange={handleItrFileChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

             {/* UPI REGISTRATION MODAL START */}
                <Modal open={openPreEmiCallingPopup} onClose={handleClosePreEmiCalling} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                    <h4 id="modal-title">{popupModalTitle}</h4>
                    <Button onClick={handleClosePreEmiCalling} color="primary" className='btn'>
                        <i className="bi bi-x"> &nbsp;</i>
                    </Button>
                    </div>
    
                    <div className='modal-body'  >
                    <form onSubmit={handleSubmit(handlePreEMICallingFormSubmit)} encType="multipart/form-data">
                        <div className="row mx-0" style={{ overflow: 'auto' ,  height: '70vh'}}>
                        
                         <div className="col-md-6">
                            <div className="form-group">
                            <label htmlFor="callDate">
                                <span>Call Date <a style={{ color: "red" }}>*</a></span>
                                <input type='date' id='callDate' name='callDate' className='form-control' {...register('callDate')} onChange={handlePreEmiCallingChange} />
                            </label>
                            </div>
                        </div>
                         <div className="col-md-6">&nbsp;</div>

                         <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="callFeedback">
                                    <span>Call Feedback </span>
                                    <textarea
                                      id="callFeedback"
                                      name="callFeedback"
                                      className="form-control"
                                      {...register("callFeedback")} 
                                      onChange={handlePreEmiCallingChange} 
                                    />
                                  </label>
                                </div>
                              </div>

                         <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="finalDisposition">
                                    <span>Final Disposition </span>
                                    <textarea
                                      id="finalDisposition"
                                      name="finalDisposition"
                                      className="form-control"
                                      {...register("finalDisposition")} 
                                      onChange={handlePreEmiCallingChange} 
                                    />
                                  </label>
                                </div>
                              </div>      
                        <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="remarks">
                                    <span>Remarks </span>
                                    <textarea
                                      id="remarks"
                                      name="remarks"
                                      className="form-control"
                                      {...register("remarks")} 
                                      onChange={handlePreEmiCallingChange} 
                                    />
                                  </label>
                                </div>
                              </div> 

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="referenceAvailable">
                                    <span>Reference Available</span>
                                    <select
                                      id="referenceAvailable"
                                      className="form-select"
                                      {...register("referenceAvailable")}
                                       onChange={handlePreEmiCallingChange}
                                    >
                                      <option value="no">No</option>
                                      <option value="yes">Yes</option>
                                      
                                    </select>
                                  </label>
                                
                                </div>
                              </div>  



                              <div className={showCreateCGCLeadStatus ? "col-md-6" : "col-md-6 d-none"}>
                                <div className="form-group">
                                 <label htmlFor="keyword">
                                        <span>Create CGC Lead</span>
                                        <input type='checkbox' name='createCGCLead' id='createCGCLead' {...register('createCGCLead')} onChange={handlePreEmiCallingChange}
                                        checked={isCreateCGCLeadChecked}
                                        />
                                    </label>
                                
                                </div>
                              </div> 
 

 <div className={showCreateCGCLeadFieldsStatus ? "col-md-12 row" : "col-md-12 row d-none"}>
        {showDuplicateAlert && duplicateLeadData && (
        <div className="col-md-12 mb-3">

            <div
                className="alert alert-warning d-flex justify-content-between align-items-center"
            >
                <div>
                    <strong>
                        Duplicate Entry Detected!
                    </strong>

                    <br />

                    Mobile already exists in system.
                </div>

                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={useDuplicateLeadData}
                >
                    USE
                </button>
            </div>

        </div>
    )}
    <hr/>
    <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="name">
            <span>
                Name <a style={{ color: "red" }}>* </a>
            </span>
            <input
                type="text"
                id="name"
                name="name"
                className=" form-control"
                {...register("name")}
                value={selectedFormItem.name}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
            {errors.name && (
            <span className="required">
                {" "}
                This field is required.
            </span>
            )}
        </div>
        </div> 

        <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="mobile">
            <span>
                Mobile <a style={{ color: "red" }}>* </a>
            </span>
            <input
                type="text"
                id="mobile"
                name="mobile"
                className=" form-control"
                {...register("mobile")}
                value={selectedFormItem.mobile}
                onChange={handlePreEmiCallingChange}
                onBlur={() => {
                    const mob = selectedFormItem.mobile;
                    if (mob && mob.length === 10 && mobileApiHitRef.current !== mob) {
                        mobileApiHitRef.current = mob;
                        getMobileDetails();
                    }
                }}
            />
            </label>
            {errors.mobile && (
            <span className="required">
                {" "}
                This field is required.
            </span>
            )}
        </div>
        </div>

        <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="address">
            <span>
                Address <a style={{ color: "red" }}>* </a>
            </span>
            <input
                type="text"
                id="address"
                name="address"
                className=" form-control"
                {...register("address")}
                value={selectedFormItem.address}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
            {errors.address && (
            <span className="required">
                {" "}
                This field is required.
            </span>
            )}
        </div>
        </div>

        <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="city">
            <span>
                City 
            </span>
            <input
                type="text"
                id="city"
                name="city"
                className=" form-control"
                {...register("city")}
                value={selectedFormItem.city}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
        </div>
        </div>

        <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="district">
            <span>
                District 
            </span>
            <input
                type="text"
                id="district"
                name="district"
                className=" form-control"
                {...register("district")}
                value={selectedFormItem.district}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
        </div>
        </div>


        <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="lead-profile">
                <span>State </span>
                <select
                    id="state"
                    name="state"
                    className="form-select"
                    {...register("state")}
                    value={selectedFormItem.state}
                    onChange={handlePreEmiCallingChange} 
                >
                    <option value=""> Select State </option>
                    {allStates.length > 0 &&
                    allStates.map((option) => (
                        <option value={option.state_code}>
                        {option.state_name}
                        </option>
                    ))}
                </select>
                </label>
            </div>
            </div>
    
      
      <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="pincode">
            <span>
                Pincode 
            </span>
            <input
                type="number"
                id="pincode"
                name="pincode"
                className=" form-control"
                {...register("pincode")}
                value={selectedFormItem.pincode}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
        </div>
        </div>


        


         <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="lead-profile">
                <span>Assigned To </span>
                <select
                    id="assigned_to"
                    name="assigned_to"
                    className="form-select"
                    {...register("assigned_to")}
                    value={selectedFormItem.assigned_to}
                    onChange={handlePreEmiCallingChange} 
                >
                    <option value=""> Select  </option>
                    {allUsersArr.length > 0 &&
                    allUsersArr.map((option) => (
                         <option key={option.user_id} value={option.user_id}>
                            {option.name}
                        </option>
                    ))}
                </select>

                
                </label>
            </div>
            </div>

            <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="lead-profile">
                <span>Type of Vehicle </span>
                <select
                    id="lead_profile"
                    name="lead_profile"
                    className="form-select"
                    {...register("lead_profile")}
                    value={selectedFormItem.lead_profile}
                    onChange={handlePreEmiCallingChange} 
                >
                    <option value=""> Select </option>
                    {allMasterProfiles.length > 0 &&
                        allMasterProfiles.map((option) => (
                            <option value={option.id}>
                            {option.lead_profile_name}
                            </option>
                        ))}
                </select>
                </label>
            </div>
            </div>
   

    <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="lead-profile">
                <span>Type of Vehicle </span>
                <select
                    id="oem_usage"
                    name="oem_usage"
                    className="form-select"
                    {...register("oem_usage")}
                    value={selectedFormItem.oem_usage}
                    onChange={handlePreEmiCallingChange} 
                >
                    <option value=""> Select </option>
                    {allOemUsage.length > 0 &&
                    allOemUsage.map((option) => (
                        <option value={option.id}>
                        {option.oem_usage_name}
                        </option>
                    ))}
                </select>
                </label>
            </div>
            </div>


            <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="lead-profile">
                <span>OEM </span>
                <select
                    id="oem"
                    name="oem"
                    className="form-select"
                    {...register("oem")}
                    value={selectedFormItem.oem}
                    onChange={handlePreEmiCallingChange} 
                >
                    <option value=""> Select </option>
                    {allOem.length > 0 &&
                        allOem.map((option) => (
                            <option
                            key={option.id}
                            value={option.id}
                            >
                            {option.oem_name}
                            </option>
                        ))}
                </select>
                </label>
            </div>
            </div>
     
    
     <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="model_name">
            <span>
                Model Name 
            </span>
            <input
                type="text"
                id="model_name"
                name="model_name"
                className=" form-control"
                {...register("model_name")}
                value={selectedFormItem.model_name}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
        </div>
        </div>


         <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="cgc_referrer_amount">
            <span>
                CGC Referrer Amount 
            </span>
            <input
                type="number"
                id="cgc_referrer_amount"
                name="cgc_referrer_amount"
                className=" form-control"
                {...register("cgc_referrer_amount")}
                value={selectedFormItem.cgc_referrer_amount}
                onChange={handlePreEmiCallingChange} 
            />
            </label>
        </div>
        </div> 
     
      
 <hr/>
</div>

                               

                         <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="referenceAvailable">
                                    <span>Assign Tele-caller</span>
                                     <select
                                        name="back_office_user_id"
                                        className="form-select"
                                        onChange={(event) => handleUAssignedTeleCallerChange(event)}
                                        ref={selectRefSL}
                                    >
                                        <option value="">Assign to User</option>
                                        {backOfficeUsersArr.map((option) => (
                                        <option key={option.user_id} value={option.user_id}>
                                            {option.name}
                                        </option>
                                        ))}
                                    </select>
                                  </label>
                                
                                </div>
                              </div>                        
                        </div>
                        <hr />

                <div className="col-md-12 mt-3">
                    <div className="d-flex justify-content-between align-items-center">

                        <button
                            type="submit"
                            className="btn btn-primary"
                        >
                            Save
                        </button>

                        {selectedItem?.history_data?.length > 0 && (
                            <button
                                type="button"
                                className="btn btn-info"
                                onClick={() => setOpenHistoryModal(true)}
                            >
                                View History ({selectedItem.history_data.length})
                            </button>
                        )}

                    </div>

                    {!isSubmitDetailEnabled && (
                            <>
                                <br />

                                <b>Lead Created :</b>

                                <span>
                                    {" "}Lead Mobile :
                                    <a
                                        href={`/dashboard/edit-lead/${btoa(selectedItem?.other_details?.linked_lead_id || '')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: "blue",
                                            textDecoration: "underline"
                                        }}
                                    >
                                        {selectedItem?.other_details?.leadMobile}
                                    </a>

                                    , Lead Name :
                                    {" "}
                                    {selectedItem?.other_details?.leadName}
                                </span>
                            </>
                        )}

                    {selectedItem?.other_details?.created_on && (
                        <div className="text-success mt-2">
                            Updated On {selectedItem?.other_details?.created_on}
                            {" "}by{" "}
                            {selectedItem?.other_details?.createdByName}
                        </div>
                    )}
                </div>
                    </form>
                    </div>
                </div>
                </Modal>
            {/* UPI REGISTRATION MODAL END */}
<Modal
    open={openHistoryModal}
    onClose={() => setOpenHistoryModal(false)}
>
    <div
        className="modal-custom rounded"
        style={{
            maxWidth: "1000px",
            width: "90%",
            margin: "40px auto",
            maxHeight: "90vh",
            overflowY: "auto"
        }}
    >
        <div className="modal-head">
            <h4>Previous Entries History</h4>

            <Button
                onClick={() => setOpenHistoryModal(false)}
                color="primary"
            >
                <i className="bi bi-x"/>
            </Button>
        </div>

        <div className="modal-body">
            <PreEmiPopUp
                details={selectedItem?.history_data || []}
            />
        </div>
    </div>
</Modal>
        

        </>
    );
}

function mapStateToProps(state) {
    return {
        getPreEmiCAllingData: state.getPreEmiCAllingData
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(reportActions.default, userActions.default, beatPlanActions.default, masterAction.default,leadActions.default,), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PreEmiCalling);   